import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHelmet } from '@agro-club/frontend-shared'

import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import InventoryInTansferSelectors from 'modules/domain/inventoryInTransferRequest/selectors'
import { useInventoryInTransferRequestList } from 'modules/domain/inventoryInTransferRequest/hooks'
import TransferRequestList, { PageTypes } from './TransferRequestList'
import { InventoryInTransferRequestActions } from 'modules/domain/inventoryInTransferRequest/duck'

const TransferInRequestsTable: React.VFC = () => {
  const { t } = useTranslation('inventorySKU')
  useHelmet({ title: t('inventoryMetaTitle') })
  const [progress, data = []] = useInventoryInTransferRequestList()
  return (
    <>
      <Layout.Header>
        <Header.TabsRoot>
          <Header.Title title={t('inventoryTransferRequest:inRequests')} />
        </Header.TabsRoot>
      </Layout.Header>
      <Layout.Content>
        <TransferRequestList
          selectors={InventoryInTansferSelectors}
          actions={InventoryInTransferRequestActions}
          pageType={PageTypes.inRequests}
          progress={progress}
          data={data}
        />
      </Layout.Content>
    </>
  )
}

export default TransferInRequestsTable
